import { authHeader } from "./auth-header";
import { endpointConstants } from "../logic/constants";
import { history } from "./history";
import { fetchCustom } from "./fetchCustom";
import Cookies from "js-cookie";

var refreshingToken = false;

const fetchTyped = (endpoint, options) => {
  const requestOptions = {
    method: options.type,
    headers: authHeader(),
    body: options.body,
  };
  return fetchCustom(endpoint, requestOptions);
};

const refreshToken = () => {
  return fetchTyped(endpointConstants.REFRESHTOKEN, {
    type: "POST",
    header: authHeader(),
    body: {},
  })
    .then((response) => {
      if (response.body.success) {
        sessionStorage.setItem("token", JSON.stringify(response.body.data));
        refreshingToken = false;
        return response;
      } else {
        sessionStorage.setItem("token", null);
        history.push("/login");
        console.log("expired refresh token");
        refreshingToken = false;
        throw response;
      }
    })
    .catch((error) => {
      sessionStorage.setItem("token", null);
      history.push("/login");
      console.log("expired refresh token");
      refreshingToken = false;
      throw error;
    });
};

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const catchErrorCode = async (error, endpoint, options) => {
  if (error.response.status === 401) {
    if (refreshingToken) {
      return sleep(300).then(() => callFetch(endpoint, options));
    } else {
      let token = JSON.parse(sessionStorage.getItem("token"));
      if (token != null) {
        console.log("refreshing token");
        refreshingToken = true;
        refreshToken();
        return callFetch(endpoint, options);
      } else {
        console.log("no need to refresh token");
      }
    }
  } else {
    throw Error(error);
  }
};

const callFetch = (endpoint, options) => {
  return fetchTyped(endpoint, options)
    .then((response) => {
      if (!response.response.ok) {
        return Promise.reject(response.response.statusText);
      } else {
        return response.body;
      }
    })
    .catch((error) => {
      return catchErrorCode(error, endpoint, options);
    })
    .then((response) => {
      return response;
    });
};

export const get = (endpoint) => {
  return callFetch(endpoint, { type: "GET" });
};

export const post = (endpoint, body) => {
  return callFetch(endpoint, { body: JSON.stringify(body), type: "POST" });
};

export const postFile = (endpoint, file) => {
  var formData = new FormData();
  formData.append("files", file, file.name);
  return callFetch(endpoint, {
    body: formData,
    type: "POST",
    headerFile: true,
  });
};

export const put = (endpoint, body) => {
  return callFetch(endpoint, { body: JSON.stringify(body), type: "PUT" });
};

export const del = (endpoint) => {
  return callFetch(endpoint, { type: "DELETE" });
};
